import { render, staticRenderFns } from "./ScheduleCalendar.vue?vue&type=template&id=d04868a0"
import script from "./ScheduleCalendar.vue?vue&type=script&lang=js"
export * from "./ScheduleCalendar.vue?vue&type=script&lang=js"
import style0 from "./ScheduleCalendar.vue?vue&type=style&index=0&id=d04868a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QAvatar,QIcon,QPopupProxy,QBanner});
